import React, { useEffect, useState } from "react";
import beautyOfJseon from "../../assets/images/website-images/beauty-of-jseon.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { convertToKebabCase, parseQueryParams } from "src/helpers/helperFunctions";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";

const BrandHoverdTab = ({
  id,
  style,
  allBrands,
  onClose,
}: {
  id: string;
  style: React.CSSProperties;
  allBrands: { brandLogo: string; [key : string]: any }[];
  onClose: () => void;
}) => {
  const navigate = useNavigate(); 

  return (
    <div id={id} className="relative p-1 pt-0 w-full h-fit min-h-[250px] xl:min-h-[300px]">
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 rounded-br-md rounded-bl-md bg-white shadow relative"
      >
        <div className="flex justify-between items-end">
          <div>
            <h2 className="font-Lexend-SemiBold font-size-35px theme-color-green">
              Brands
            </h2>
            <p className="font-size-18px font-Poppins-Regular under-dropdown-text">
              Explore all brands
            </p>
          </div>
          <div
            className="font-size-16px font-Poppins-SemiBold theme-color-green-3f underline cursor-pointer"
            onClick={() => {
              onClose();
              navigate("/brands");
            }}
          > 
            View All
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 xl:gap-4 mt-3 xl:mt-4">
          {allBrands?.slice(0, 18)?.map((item, index) => (
            <div
              key={index}
              className="w-full h-[90px] 2xl:h-[120px] bg-white shadow-all rounded-md flex items-center justify-center cursor-pointer"
              onClick={() => {
                navigate(
                  `/brand/${convertToKebabCase(item?.brandName || "")}?${parseQueryParams({
                    [QueryPath.brand]: item?._id,
                    [QueryPath.brandName]: item?.brandName,
                  })}`,
                );
                onClose();
              }}
              id={`brand-${index + 1}`}
            >
              <img
                src={item?.brandLogo}
                alt="brand"
                className="max-w-[80%] max-h-[90%] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandHoverdTab;
